module.exports = "query productSearchTotals($userId:String){productSearchTotals(userId:$userId){all public favorite featured previouslyOrdered}}"